import { Box, Typography, Button, LinearProgress, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, Chip, TablePagination, Tooltip } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { useTheme } from '@mui/material/styles'
import { useRrhh } from '../../../../shared/context/rrhhContext'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useUtiles } from '../../../../shared/context/utilesContext'
export default function ListComponent() {
    const theme = useTheme()
    const {locationString} = useUtiles()
    const { rrhh, loadingRrhh, getRrhh, pagination, setPagination } = useRrhh()
    const navigate = useNavigate()
    useEffect(() => {
        getRrhh()
    }, [])

    const handleEditRrhh = (hashCode) => {
        navigate(`/rrhh/editar/${hashCode}`)
    }
    return (
        <>
             <TableContainer component={Paper} sx={{ "&.MuiPaper-root": { borderRadius: '10px', boxShadow: 'none' }, height: '70vh', overflow: 'auto' }}>
                <Table sx={{ minWidth: 1500, overflowX: 'auto' }} aria-label="simple table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Documento</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '300px' }}>Nombre</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '250px' }}>Email</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '300px' }}>Cargo</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Teléfono</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '250px' }}>Ubicación</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '250px' }}>Rol</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Habilitado</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rrhh.map((item) => (
                                <TableRow key={item.id} onClick={() => handleEditRrhh(item.hash_code)} sx={{ cursor: 'pointer' }}>
                                    <TableCell>{item.num_document}</TableCell>
                                    <TableCell>{item.fullName}</TableCell>
                                    <TableCell>{item.email}</TableCell>
                                    <TableCell>{item.position}</TableCell>
                                    <TableCell>{item.phone}</TableCell>
                                    <TableCell>{locationString(item.location)}</TableCell>
                                    <TableCell>
                                        {
                                            item.role ? 
                                            <Tooltip title={item.role?.description}>
                                                <Chip label={item.role?.name} color="primary" sx={{ fontSize: '12px', color: "#fff", fontWeight: 'bold' }} />
                                            </Tooltip>
                                            :
                                            <Chip label="Sin rol"  sx={{ fontSize: '12px', color: "#fff", fontWeight: 'bold' }} />
                                        }
                                    </TableCell>
                                    <TableCell>{item.is_active ? <Chip label="Habilitado" color="success" sx={{ fontSize: '12px', color: "#fff", fontWeight: 'bold' }} /> : <Chip label="Inhabilitado" color="error" sx={{ fontSize: '12px', color: "#fff", fontWeight: 'bold' }} />}</TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mt: 2,  }}>
                <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component="div"
                    count={pagination.count || 0}
                    rowsPerPage={pagination.per_page || 20}
                    page={(pagination.current_page || 0) - 1}
                    onPageChange={(event, newPage) => {
                        console.log(pagination)
                        setPagination({ ...pagination, current_page: newPage });
                        getRrhh({ ...pagination, page: newPage + 1 });
                    }}
                    onRowsPerPageChange={(event) => {
                        setPagination({ ...pagination, per_page: parseInt(event.target.value) });
                        getRrhh({ ...pagination, page: 1, per_page: event.target.value });
                    }}
                    labelRowsPerPage="Registros por página"
                    sx={{
                        "& .MuiTablePagination-root": {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            mt: 2
                        }
                    }}
                />
            </Box>
        </>
    )
}
